import { render, staticRenderFns } from "./RequestDetailPrint.vue?vue&type=template&id=f9864632&scoped=true&"
import script from "./RequestDetailPrint.vue?vue&type=script&lang=js&"
export * from "./RequestDetailPrint.vue?vue&type=script&lang=js&"
import style0 from "./RequestDetailPrint.vue?vue&type=style&index=0&id=f9864632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9864632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
